const libPictView = require('pict-view');
const libLayout = require('./PictView-Layout.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'Signature',
	DefaultRenderable: 'Signature-Display',
	CSS: /*css*/`
		.cst-sig { display: flex; flex-direction: column; gap: 6px; min-height: 0; flex: 1 1 auto; }
		#Signature-PromptRows { overflow-y: auto; min-height: 0; flex: 1 1 auto; }
		.cst-sig-title { font-size: 11px; color: var(--theme-color-text-secondary, #5b6376); text-transform: uppercase; letter-spacing: 0.04em; }
		.cst-sig-strip
		{
			position: relative;
			display: flex;
			height: 18px;
			width: 100%;
			border-radius: 4px;
			overflow: hidden;
			background: var(--theme-color-border-light, #e3e6ee);
			cursor: pointer;
		}
		.cst-sig-seg
		{
			height: 100%;
			min-width: 1px;
			transition: filter 0.1s;
		}
		.cst-sig-seg:hover { filter: brightness(1.15) saturate(1.2); }
		.cst-sig-seg-userprompt   { background: #2e8b57; }
		.cst-sig-seg-assistant    { background: var(--theme-color-brand-primary, #4a7ad6); }
		.cst-sig-seg-thinking     { background: #6f88c7; }
		.cst-sig-seg-tool-read    { background: var(--theme-color-brand-accent, #b07acc); }
		.cst-sig-seg-tool-write   { background: #d18ba2; }
		.cst-sig-seg-tool-bash    { background: #c87a3a; }
		.cst-sig-seg-tool-search  { background: #d4b94a; }
		.cst-sig-seg-tool-agent   { background: #e07b3a; }
		.cst-sig-seg-tool-other   { background: #9b8fb1; }
		.cst-sig-seg-tool-result  { background: #c8c5dd; }
		.cst-sig-seg-attachment   { background: #b8c4d6; }
		.cst-sig-seg-system       { background: var(--theme-color-status-error, #c0353a); }
		.cst-sig-seg-gap
		{
			background:
				repeating-linear-gradient(
					45deg,
					#9aa1b1 0,
					#9aa1b1 4px,
					#7a8092 4px,
					#7a8092 8px);
		}
		.cst-sig-prompt-row { display: flex; align-items: center; gap: 8px; }
		.cst-sig-prompt-label { width: 22px; text-align: right; font-size: 10px; color: var(--theme-color-text-secondary, #5b6376); flex: 0 0 auto; }
		.cst-sig-prompt-strip { flex: 1 1 auto; height: 10px; border-radius: 2px; background: var(--theme-color-border-light, #e3e6ee); display: flex; overflow: hidden; cursor: pointer; }
		.cst-sig-prompt-strip .cst-sig-seg { height: 100%; }
		.cst-sig-prompt-meta { font-size: 10px; color: var(--theme-color-text-secondary, #5b6376); flex: 0 0 auto; min-width: 110px; text-align: right; }
		.cst-sig-legend { display: flex; flex-wrap: wrap; gap: 10px; font-size: 10px; color: var(--theme-color-text-secondary, #5b6376); }
		.cst-sig-legend-item { display: flex; align-items: center; gap: 4px; }
		.cst-sig-legend-swatch { width: 10px; height: 10px; border-radius: 2px; }
		.cst-sig-tooltip
		{
			position: absolute;
			background: var(--theme-color-text-primary, #1d2230);
			color: var(--theme-color-background-panel, #fff);
			padding: 4px 7px;
			border-radius: 3px;
			font-size: 11px;
			pointer-events: none;
			transform: translate(-50%, -130%);
			white-space: nowrap;
			z-index: 10;
			opacity: 0;
			transition: opacity 0.1s;
		}
		.cst-sig-tooltip.cst-sig-tooltip-visible { opacity: 1; }
	`,
	Templates:
	[
		{
			Hash: 'Signature-Display',
			Template: /*html*/`
<div class="cst-sig">
	<div class="cst-sig-title">Session signature — active time + idle gaps (compressed)</div>
	<div class="cst-sig-strip" id="Signature-MainStrip"
		onmousemove="_Pict.views.Signature.onStripHover(event, this)"
		onmouseleave="_Pict.views.Signature.hideTooltip()"
		onclick="_Pict.views.Signature.onStripClick(event, this)">
	</div>
	<div id="Signature-PromptRows"></div>
	<div class="cst-sig-legend">
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-userprompt"></span>prompt</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-assistant"></span>assistant text</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-thinking"></span>thinking</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-tool-read"></span>read</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-tool-write"></span>write/edit</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-tool-bash"></span>bash</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-tool-search"></span>search</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-tool-agent"></span>agent</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-tool-other"></span>other tool</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-system"></span>system/error</span>
		<span class="cst-sig-legend-item"><span class="cst-sig-legend-swatch cst-sig-seg-gap"></span>idle (compressed)</span>
	</div>
	<div class="cst-sig-tooltip" id="Signature-Tooltip"></div>
</div>`
		}
	],
	Renderables:
	[
		{
			RenderableHash: 'Signature-Display',
			TemplateHash:   'Signature-Display',
			ContentDestinationAddress: '#Signature-Container'
		}
	]
};

class PictViewSignature extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		this._segments = [];                              // current main strip segments (for hover lookup)
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		this._renderMainStrip();
		this._renderPromptRows();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}

	_renderMainStrip()
	{
		let tmpSession = this.pict.AppData.Session;
		if (!tmpSession || !tmpSession.Turns || !tmpSession.Turns.length) return;

		let tmpSegments = this._buildSegments(tmpSession.Turns);
		let tmpFirst = tmpSession.Turns[0].TimestampMs;
		let tmpLast = tmpSession.Turns[tmpSession.Turns.length - 1].TimestampMs || tmpFirst;
		let tmpScale = this._buildCompressedScale(tmpSegments, tmpFirst, tmpLast);
		let tmpHTML = '';
		this._segments = [];
		for (let i = 0; i < tmpSegments.length; i++)
		{
			let tmpSeg = tmpSegments[i];
			let tmpStartPct = tmpScale.toPct(tmpSeg.StartMs);
			let tmpEndPct = tmpScale.toPct(tmpSeg.EndMs);
			let tmpWidthPct = Math.max(tmpEndPct - tmpStartPct, 0);
			if (tmpWidthPct < 0.05) tmpWidthPct = 0.05;
			tmpSeg.RenderStartPct = tmpStartPct;
			tmpSeg.RenderEndPct = tmpStartPct + tmpWidthPct;
			this._segments.push(tmpSeg);
			tmpHTML += '<div class="cst-sig-seg cst-sig-seg-' + tmpSeg.ColorClass + '" '
				+ 'style="width:' + tmpWidthPct.toFixed(3) + '%" '
				+ 'data-seg="' + i + '"></div>';
		}
		this.pict.ContentAssignment.assignContent('#Signature-MainStrip', tmpHTML);
	}

	_renderPromptRows()
	{
		let tmpSession = this.pict.AppData.Session;
		if (!tmpSession || !tmpSession.Prompts || !tmpSession.Prompts.length) return;

		let tmpRowsHTML = '';
		for (let i = 0; i < tmpSession.Prompts.length; i++)
		{
			let tmpGroup = tmpSession.Prompts[i];
			// Pull the slice of turns for this prompt group.
			let tmpTurns = [];
			for (let j = 0; j < tmpGroup.TurnIndices.length; j++)
			{
				tmpTurns.push(tmpSession.Turns[tmpGroup.TurnIndices[j]]);
			}
			if (!tmpTurns.length) continue;
			let tmpSegments = this._buildSegments(tmpTurns);
			let tmpFirst = tmpGroup.FirstTimestampMs;
			let tmpLast = tmpGroup.LastTimestampMs || tmpFirst;
			let tmpScale = this._buildCompressedScale(tmpSegments, tmpFirst, tmpLast);
			let tmpStripHTML = '';
			for (let k = 0; k < tmpSegments.length; k++)
			{
				let tmpSeg = tmpSegments[k];
				let tmpW = tmpScale.toPct(tmpSeg.EndMs) - tmpScale.toPct(tmpSeg.StartMs);
				if (tmpW < 0.05) tmpW = 0.05;
				tmpStripHTML += '<div class="cst-sig-seg cst-sig-seg-' + tmpSeg.ColorClass + '" '
					+ 'style="width:' + tmpW.toFixed(3) + '%"></div>';
			}
			let tmpTitle = (tmpGroup.Title || 'prompt ' + (i + 1)).replace(/"/g, '&quot;');
			tmpRowsHTML += '<div class="cst-sig-prompt-row" title="' + tmpTitle + '">'
				+ '<span class="cst-sig-prompt-label">#' + (i + 1) + '</span>'
				+ '<span class="cst-sig-prompt-strip" onclick="_Pict.views.Conversation.scrollToPrompt(\'' + tmpGroup.PromptId + '\')">'
				+ tmpStripHTML
				+ '</span>'
				+ '<span class="cst-sig-prompt-meta">'
				+ libLayout.formatDuration(tmpGroup.TotalDurationMs) + ' · '
				+ tmpGroup.ToolCallCount + 't'
				+ (tmpGroup.AgentCallCount ? ' · ' + tmpGroup.AgentCallCount + 'a' : '')
				+ '</span>'
				+ '</div>';
		}
		this.pict.ContentAssignment.assignContent('#Signature-PromptRows', tmpRowsHTML);
	}

	_buildSegments(pTurns)
	{
		// Each turn becomes one (or more, for assistant turns with multiple tool_use blocks) segments;
		// gaps are emitted as their own segment with the "gap" color class.
		let tmpSegments = [];
		for (let i = 0; i < pTurns.length; i++)
		{
			let tmpTurn = pTurns[i];
			let tmpStart = tmpTurn.TimestampMs;
			let tmpEnd = (i + 1 < pTurns.length && pTurns[i + 1].TimestampMs)
				? pTurns[i + 1].TimestampMs
				: tmpStart + 1000;                     // tail segment minimum width
			if (!tmpStart) continue;

			if (tmpTurn.Kind === 'gap')
			{
				tmpSegments.push({
					Kind: 'gap',
					ColorClass: 'gap',
					StartMs: tmpStart,
					EndMs: tmpTurn.EndTimestampMs || tmpEnd,
					IsGap: true,
					Label: 'idle ' + libLayout.formatDuration(tmpTurn.DurationMs),
					TurnIndex: i
				});
				continue;
			}

			let tmpColor = this._colorForTurn(tmpTurn);
			tmpSegments.push({
				Kind: tmpTurn.Kind,
				ColorClass: tmpColor.Class,
				Label: tmpColor.Label,
				StartMs: tmpStart,
				EndMs: tmpEnd,
				IsGap: false,
				TurnIndex: i,
				PromptId: tmpTurn.PromptId
			});
		}
		return tmpSegments;
	}

	_colorForTurn(pTurn)
	{
		if (pTurn.Kind === 'user-prompt') return { Class: 'userprompt', Label: 'user prompt' };
		if (pTurn.Kind === 'tool-result') return { Class: 'tool-result', Label: 'tool result' };
		if (pTurn.Kind === 'attachment')  return { Class: 'attachment',  Label: 'attachment' };
		if (pTurn.Kind === 'system')      return { Class: 'system',      Label: 'system / hook' };
		if (pTurn.Kind === 'assistant')
		{
			// Pick the dominant block in this assistant turn.
			let tmpHasToolUse = false;
			let tmpToolName = null;
			let tmpHasThinking = false;
			let tmpHasText = false;
			for (let i = 0; i < pTurn.Blocks.length; i++)
			{
				let tmpB = pTurn.Blocks[i];
				if (tmpB.Type === 'tool_use') { tmpHasToolUse = true; if (!tmpToolName) tmpToolName = tmpB.Name; }
				if (tmpB.Type === 'thinking') tmpHasThinking = true;
				if (tmpB.Type === 'text')     tmpHasText = true;
			}
			if (tmpHasToolUse)
			{
				let tmpFamily = toolFamily(tmpToolName);
				return { Class: 'tool-' + tmpFamily, Label: tmpToolName || 'tool' };
			}
			if (tmpHasText)     return { Class: 'assistant', Label: 'assistant text' };
			if (tmpHasThinking) return { Class: 'thinking',  Label: 'thinking' };
			return { Class: 'assistant', Label: 'assistant' };
		}
		return { Class: 'attachment', Label: pTurn.Kind };
	}

	_buildCompressedScale(pSegments, pFirstMs, pLastMs)
	{
		// Active spans (non-gap) get linear time. Gaps share a fixed budget logarithmically.
		// This means a 5h gap becomes a visible sliver, but doesn't dominate.
		let tmpActiveTotal = 0;
		let tmpGaps = [];
		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpDur = Math.max(0, pSegments[i].EndMs - pSegments[i].StartMs);
			if (pSegments[i].IsGap) tmpGaps.push(tmpDur);
			else tmpActiveTotal += tmpDur;
		}
		// Map each gap to a compressed weight: log10(1 + minutes) — a 1-min gap ≈ 0.04, a 5h gap ≈ 2.5.
		let tmpGapWeights = tmpGaps.map((pMs) => Math.log10(1 + pMs / 60000));
		let tmpGapWeightTotal = tmpGapWeights.reduce((pA, pB) => pA + pB, 0);

		// Allocate 75% of the strip to active time, 25% to gap weights — but if there are no gaps,
		// active gets 100%; if there's no active time, gaps get everything.
		let tmpActiveBudget = tmpGapWeightTotal > 0 ? 0.75 : 1.0;
		let tmpGapBudget    = tmpGapWeightTotal > 0 ? 0.25 : 0.0;
		if (tmpActiveTotal === 0) { tmpActiveBudget = 0; tmpGapBudget = 1.0; }

		// Build a piecewise mapping from real-ms → strip-fraction.
		let tmpAnchors = [{ Ms: pFirstMs, Pct: 0 }];
		let tmpGapIdx = 0;
		let tmpRunPct = 0;
		for (let i = 0; i < pSegments.length; i++)
		{
			let tmpSeg = pSegments[i];
			let tmpDur = Math.max(0, tmpSeg.EndMs - tmpSeg.StartMs);
			let tmpDeltaPct;
			if (tmpSeg.IsGap)
			{
				let tmpW = tmpGapWeights[tmpGapIdx++] || 0;
				tmpDeltaPct = tmpGapWeightTotal > 0 ? (tmpW / tmpGapWeightTotal) * tmpGapBudget * 100 : 0;
			}
			else
			{
				tmpDeltaPct = tmpActiveTotal > 0 ? (tmpDur / tmpActiveTotal) * tmpActiveBudget * 100 : 0;
			}
			tmpRunPct += tmpDeltaPct;
			tmpAnchors.push({ Ms: tmpSeg.EndMs, Pct: tmpRunPct });
		}

		return {
			toPct: (pMs) =>
			{
				// Find the bracketing anchors and interpolate linearly.
				if (pMs <= tmpAnchors[0].Ms) return tmpAnchors[0].Pct;
				if (pMs >= tmpAnchors[tmpAnchors.length - 1].Ms) return tmpAnchors[tmpAnchors.length - 1].Pct;
				for (let i = 1; i < tmpAnchors.length; i++)
				{
					let tmpPrev = tmpAnchors[i - 1];
					let tmpCur = tmpAnchors[i];
					if (pMs <= tmpCur.Ms)
					{
						let tmpRange = tmpCur.Ms - tmpPrev.Ms;
						if (tmpRange <= 0) return tmpCur.Pct;
						let tmpRatio = (pMs - tmpPrev.Ms) / tmpRange;
						return tmpPrev.Pct + tmpRatio * (tmpCur.Pct - tmpPrev.Pct);
					}
				}
				return tmpAnchors[tmpAnchors.length - 1].Pct;
			}
		};
	}

	onStripHover(pEvent, pStrip)
	{
		let tmpRect = pStrip.getBoundingClientRect();
		let tmpPct = ((pEvent.clientX - tmpRect.left) / tmpRect.width) * 100;
		let tmpSeg = null;
		for (let i = 0; i < this._segments.length; i++)
		{
			if (this._segments[i].RenderStartPct <= tmpPct && this._segments[i].RenderEndPct >= tmpPct)
			{
				tmpSeg = this._segments[i];
				break;
			}
		}
		if (!tmpSeg) { this.hideTooltip(); return; }
		let tmpDate = new Date(tmpSeg.StartMs);
		let tmpDur = libLayout.formatDuration(tmpSeg.EndMs - tmpSeg.StartMs);
		let tmpLabel = (tmpSeg.IsGap ? tmpSeg.Label : tmpSeg.Label + ' · ' + tmpDur)
			+ ' · ' + tmpDate.toLocaleString();
		let tmpTip = document.getElementById('Signature-Tooltip');
		if (!tmpTip) return;
		tmpTip.textContent = tmpLabel;
		tmpTip.style.left = (pEvent.clientX - tmpRect.left + pStrip.offsetLeft) + 'px';
		tmpTip.style.top = (pStrip.offsetTop) + 'px';
		tmpTip.classList.add('cst-sig-tooltip-visible');
	}

	hideTooltip()
	{
		let tmpTip = document.getElementById('Signature-Tooltip');
		if (tmpTip) tmpTip.classList.remove('cst-sig-tooltip-visible');
	}

	onStripClick(pEvent, pStrip)
	{
		let tmpRect = pStrip.getBoundingClientRect();
		let tmpPct = ((pEvent.clientX - tmpRect.left) / tmpRect.width) * 100;
		for (let i = 0; i < this._segments.length; i++)
		{
			if (this._segments[i].RenderStartPct <= tmpPct && this._segments[i].RenderEndPct >= tmpPct)
			{
				if (this.pict.views.Conversation && this._segments[i].PromptId)
				{
					this.pict.views.Conversation.scrollToPrompt(this._segments[i].PromptId);
				}
				else if (this.pict.views.Conversation)
				{
					this.pict.views.Conversation.scrollToTurn(this._segments[i].TurnIndex);
				}
				return;
			}
		}
	}
}

function toolFamily(pName)
{
	if (!pName) return 'other';
	if (/^Read|Glob|^NotebookRead/i.test(pName)) return 'read';
	if (/^(Write|Edit|NotebookEdit|MultiEdit)/i.test(pName)) return 'write';
	if (/^Bash/i.test(pName)) return 'bash';
	if (/^(Grep|WebSearch|WebFetch|Search)/i.test(pName)) return 'search';
	if (/^(Task|Agent|Subagent)/i.test(pName)) return 'agent';
	return 'other';
}

module.exports = PictViewSignature;
module.exports.default_configuration = _ViewConfiguration;
module.exports.toolFamily = toolFamily;
